<div ngClass.lt-md="mobile" fxLayout="column" fxLayout.lt-md="column">
  <div
    *ngFor="let convo of conversationUi"
    class="message"
    [ngClass]="{
      'left-message': convo.position === ConversationPosition.Left,
      'right-message': convo.position === ConversationPosition.Right
    }">
    <div class="message-img" *ngIf="convo?.from?.initials" [ngClass]="{ 'has-platform-icon': convo?.from?.channel }">
      {{ convo?.from?.initials }}
      <sbnb-icon-platform
        class="platform-icon"
        *ngIf="convo?.from?.channel"
        [platform]="convo?.from?.channel"></sbnb-icon-platform>
    </div>
    <div class="message-bubble" [ngClass]="{ 'no-initials': !convo?.from?.initials }">
      <div class="message-text">
        <span *ngIf="!convo.isTyping" [innerHtml]="convo.text"></span>
        <span *ngIf="convo.isTyping">
          <div class="half light">
            <div class="typing">
              <span class="circle scaling"></span>
              <span class="circle scaling"></span>
              <span class="circle scaling"></span>
            </div>
          </div>
        </span>
      </div>
    </div>
    <div *ngIf="!convo.isTyping && convo?.hint" class="break"></div>
    <div *ngIf="!convo.isTyping && convo?.hint" class="message-hint" fxLayout="row" [innerHtml]="convo?.hint"></div>
  </div>

  <div *ngIf="showNewMessageInput" class="message-input--container" fxLayout="column">
    <div fxLayout="row" style="align-items: flex-end">
      <input type="text" class="message-input" placeholder="Type a message" />
      <div class="message-img">
        {{ senderInitials }}
      </div>
    </div>
    <div
      *ngIf="newMessageHint"
      (click)="onClickMessageHint($event.target)"
      class="message-hint"
      fxLayout="row"
      [innerHtml]="newMessageHint"></div>
  </div>
</div>
